<template>
	<div>
		<ul class="d-flex flex-wrap align-items-center" :class="{ 'opacity-50': disabled }">
			<li
                id="week-days"
				class="text-center font-weight-600 m-1 border-dark radius-circle bg-lightest dark fs-smallest"
				style="width: 1.9rem; height: 1.9rem; padding-top: 0.45rem;"
				v-for="day in weekDays"
				:class="{'active': day.active, 'pointer': !disabled, 'notAllowed': !day.isValid}"
				@click="toggleDay($event, day)"
			>
				{{ day.nameSmall }}
			</li>
		</ul>

		<span class="dark fs-smaller pointer text-center">
			<span v-if="selectedValidDays.length === validDays.length" @click="deselectAllWeekDays">Deselect all</span>
			<span v-else @click="selectAllWeekDays">Select all</span>
		</span>

		<div v-if="errorMessage" class="error fs-small mt-1">
			<span>{{ errorMessage }}</span>
		</div>
	</div>
</template>
  
<script>
export default {
	data: function() {
		return {
			weekDays: [
				{ id: 1, active: false, isValid: true, name: 'Monday', nameSmall:'Mon',  value: 'M' },
				{ id: 2, active: false, isValid: true, name: 'Tuesday', nameSmall:'Tue',  value: 'T' },
				{ id: 3, active: false, isValid: true, name: 'Wednesday', nameSmall:'Wed',  value: 'W' },
				{ id: 4, active: false, isValid: true, name: 'Thursday', nameSmall:'Thu',  value: 'T' },
				{ id: 5, active: false, isValid: true, name: 'Friday', nameSmall:'Fri',  value: 'F' },
				{ id: 6, active: false, isValid: true, name: 'Saturday', nameSmall:'Sat',  value: 'S' },
				{ id: 0, active: false, isValid: true, name: 'Sunday', nameSmall:'Sun',  value: 'S' },
			],
		}
	},
	props: {
		value: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default: false
		},
		dateRange: {
			type: Array,
			default: () => []
		}
	},
	watch: {
		value(newValue) {
			this.mutableValue = newValue;
			this.updateActiveDays();
		},
		dateRange() {
			this.updateValidDays();
		}
	},
    created() {
		this.mutableValue = this.value;
		this.updateActiveDays();
		this.updateValidDays();
	},
	computed: {
		mutableValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit('input', newValue);
			}
		},
		validDays() {
            // Returns allowed days from dateRange, including every day in between.
			if (!this.dateRange || this.dateRange.length === 0) return [];
			
			if (this.dateRange.length === 2) {
				const start = new Date(this.dateRange[0]);
				const end = new Date(this.dateRange[1]);
				const days = [];
				const currentDate = new Date(start);
				
				while (currentDate <= end) {
					days.push(currentDate.getDay());
					currentDate.setDate(currentDate.getDate() + 1);
				}

				// Removes duplicates (if the range spans more than a week)
				return [...new Set(days)];
			} else {
				return this.dateRange.map(date => new Date(date).getDay());
			}
		},
		selectedValidDays() {
            // Returns only the valid selected days
			return this.mutableValue.filter(dayId => this.validDays.includes(dayId));
		},
		errorMessage() {
            // Returns error message: 'Repeat weekly is required' if no day is selected, or 'The selected weekdays do not match the chosen dates' if any invalid day is selected.
			const validActive = this.weekDays.some(wd => wd.isValid && wd.active);
			const invalidActive = this.weekDays.some(wd => !wd.isValid && wd.active);
			const isActive = validActive && !invalidActive;
			this.$emit('hasWeekDays', isActive);

			if (this.mutableValue.length === 0) {
				return 'Repeat weekly is required - select at least one day of the week';
			}
			
            const invalidSelected = this.mutableValue.filter(dayId => !this.validDays.includes(dayId));
			
            if (invalidSelected.length > 0) {
				return 'The selected weekdays do not match the chosen dates';
			}

            return '';
		}
	},
	methods: {
		toggleDay(event, day) {
			if (this.disabled === true) {
				return;
			}

			let newDay = true;
			this.mutableValue.forEach((storedDay, storedDayIndex) => {
				if(storedDay === day.id){
					newDay = false;
					this.mutableValue.splice(storedDayIndex, 1);
				}
			});

			if (newDay) {
				this.mutableValue.push(day.id);
			}

			this.updateActiveDays();
			this.$emit('change', this.mutableValue);
		},
		updateActiveDays() {
			this.weekDays.forEach(weekDay => {
				weekDay.active = this.mutableValue.includes(weekDay.id);
			});
		},
		updateValidDays() {
			if (!this.dateRange || this.dateRange.length === 0) return;
			const allowedDays = this.validDays;
			this.weekDays.forEach(day => {
				day.isValid = allowedDays.includes(day.id);
			});

			this.updateActiveDays();
			this.$emit('change', this.mutableValue);
		},
		selectAllWeekDays() {
			if (this.disabled === true) {
				return;
			}

			// Selects only the valid days based on dateRange
			const validDayIds = this.weekDays.filter(day => day.isValid).map(day => day.id);
			this.mutableValue = validDayIds;
			this.updateActiveDays();
			this.$emit('change', this.mutableValue);
		},
		deselectAllWeekDays() {
			if (this.disabled === true) {
				return;
			}

			this.mutableValue = [];
			this.updateActiveDays();
			this.$emit('change', this.mutableValue);
		}
	}
}
</script>
  
<style lang="scss" scoped>
	@import '../../../../assets/scss/_variables.scss';
	
	li.active {
		background-color: $color-1 !important;
		border-color: $color-1 !important;
		color: $lightest !important;
	}
	
	li#week-days.notAllowed {
		opacity: 0.5;
		cursor: not-allowed;
	}
</style>



// WEBPACK FOOTER //
// WeekDayPicker.vue?e8ae456c